import i18n from '@/plugins/i18n';
const connectionsMONGOGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.opcounters'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_opcounters',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      show: true,
      showForSingleSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.operationExecutionTimes'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_operation_execution_times',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      aggregationNum: '1048576',
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.queryService'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_query_executor,meter_mongodb_query_targeting',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.numberOfConnections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_connections_active',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.queues'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_queues',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.scanAndOrder'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_scanandorder',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
  ],
});

export default connectionsMONGOGraphs;
